import { mutationTypes } from './mutations';
import api from './api'

export const actionTypes = {
	pagesLoad: 'pagesLoad',
	pagesCreate: 'pagesCreate',
	pagesUpdate: 'pagesUpdate',
	pagesDelete: 'pagesDelete',
	pagesValidate: 'pagesValidate',
	pagesValidationClear: 'pagesValidationClear',
	pagesValidationModalClose: 'pagesValidationModalClose',
	pagesFilesLoad: 'pagesFilesLoad',
	pagesFilesCreate: 'pagesFilesCreate',
	pagesFilesUpdate: 'pagesFilesUpdate',
	pagesFilesDelete: 'pagesFilesDelete',
	pagesSnippetsLoad: 'pagesSnippetsLoad',
	pagesSnippetsCreate: 'pagesSnippetsCreate',
	pagesSnippetsUpdate: 'pagesSnippetsUpdate',
	pagesSnippetsDelete: 'pagesSnippetsDelete',
};

// TODO: add snippet validation

export default {
	[actionTypes.pagesLoad]({ commit }) {
		return api.pagesLoad()
			.then(data => commit(mutationTypes.PAGES_LOAD, data))		
	},
	async [actionTypes.pagesCreate]({ commit, dispatch }, page) {		
		const result = await dispatch(actionTypes.pagesValidate, page)
		if (result === true)
			return api.pagesCreate(page)
				.then(res => {
					commit(mutationTypes.PAGES_CREATE, res.data)
					return res.data
				})
				.catch(error => {
					commit(mutationTypes.PAGES_VALIDATION_MODAL, true)
					commit(mutationTypes.PAGES_VALIDATION_ERRORS, error.response.data.errors)
					return Promise.reject(error)
				})
		commit(mutationTypes.PAGES_VALIDATION_MODAL, true)
		commit(mutationTypes.PAGES_VALIDATION_ERRORS, result)
		return Promise.reject()
	},
	async [actionTypes.pagesUpdate]({ commit, dispatch }, page) {
		const result = await dispatch(actionTypes.pagesValidate, page)
		if (result === true)
			return api.pagesUpdate(page)
				.then(res => commit(mutationTypes.PAGES_UPDATE, res.data))
				.catch(error => {
					commit(mutationTypes.PAGES_VALIDATION_MODAL, true)
					commit(mutationTypes.PAGES_VALIDATION_ERRORS, error.response.data.errors)
					return Promise.reject(error)
				})
		commit(mutationTypes.PAGES_VALIDATION_MODAL, true)
		commit(mutationTypes.PAGES_VALIDATION_ERRORS, result)
		return Promise.reject()
	},
	[actionTypes.pagesDelete]({ commit }, page) {
		api.pagesDelete(page)
			.then(data => commit(mutationTypes.PAGES_DELETE, page))
	},
	[actionTypes.pagesValidate]({ commit }, page) {
		let result = {}
		if (page.title.length < 4 || page.title.length > 255)
			result['title'] = 'The title is needed and should be between 4 and 255 letters long'
		if (page.slug.length < 2 || page.slug.length > 50)
			result['slug'] = 'The slug is needed and should be between 2 and 50 letters long'
		if (page.seoDescription && page.seoDescription.length > 500)
			result['seoDescription'] = 'The SEO Description should be no more than 500 letters long'
		if (page.seoTags && page.seoTags.length > 500)
			result['seoTags'] = 'The SEO Tags should be no more than 500 letters long'
		if (page.body.length < 8)
			result['body'] = 'The body of the page cannot be empty'	
		
		if (Object.keys(result).length == 0) {
			commit(mutationTypes.PAGES_VALIDATION_CLEAR, result)
			return true
		}
		else {
			commit(mutationTypes.PAGES_VALIDATION_ERRORS, result)
			return result
		}
	},
	[actionTypes.pagesValidationClear]({ commit }) {
		commit(mutationTypes.PAGES_VALIDATION_CLEAR)	
	},
	[actionTypes.pagesValidationModalClose]({ commit }) {
		commit(mutationTypes.PAGES_VALIDATION_MODAL, false)		
	},
	[actionTypes.pagesFilesLoad]({ commit }) {
		return api.pagesFilesLoad()
			.then(data => commit(mutationTypes.PAGES_FILES_LOAD, data))		
	},
	[actionTypes.pagesFilesCreate]({ commit }, pageFile) {		
		api.pagesFilesCreate(pageFile)
			.then(data => commit(mutationTypes.PAGES_FILES_CREATE, data))
	},	
	[actionTypes.pagesFilesUpdate]({ commit }, file) {	
		api.pagesFilesUpdate(file)
			.then(data => commit(mutationTypes.PAGES_FILES_UPDATE, data))
	},	
	[actionTypes.pagesFilesDelete]({ commit }, pageFile) {		
		api.pagesFilesDelete(pageFile)
			.then(data => commit(mutationTypes.PAGES_FILES_DELETE, pageFile))
	},
	[actionTypes.pagesSnippetsLoad]({ commit }) {
		return api.snippetsLoad()
			.then(data => {				
				const container = document.getElementById("templates")			
				for (let i=0; i<data.length; i++) {
					const template = document.createElement("script")
					const attrType = document.createAttribute('type')
					attrType.value = 'text/x-template'
					template.setAttributeNode(attrType)
					const attrId = document.createAttribute('id')
					attrId.value = data[i].slug
					template.setAttributeNode(attrId)
					template.innerHTML = data[i].body
					container.appendChild(template)
				}
				commit(mutationTypes.PAGES_SNIPPETS_LOAD, data)
			})	
				
	},
	[actionTypes.pagesSnippetsCreate]({ commit }, snippet) {		
		api.snippetsCreate(snippet)
			.then(res => commit(mutationTypes.PAGES_SNIPPETS_CREATE, res.data))
	},	
	[actionTypes.pagesSnippetsUpdate]({ commit }, snippet) {		
		api.snippetsUpdate(snippet)
			.then(res => commit(mutationTypes.PAGES_SNIPPETS_UPDATE, res.data))
	},	
	[actionTypes.pagesSnippetsDelete]({ commit }, snippet) {		
		api.snippetsDelete(snippet)
			.then(data => commit(mutationTypes.PAGES_SNIPPETS_DELETE, snippet))
	},
	[actionTypes.clearValidation]({ commit }) {		
		commit(mutationTypes.CLEAR_VALIDATION)
	},
};
